import React, { useState, useEffect } from "react";
import { Button, Collapse, Input, Label } from "reactstrap";
import { getJobIndustries } from "../../../../api/categories";

const JobType = ({ onFilterChange, handleClearFilter, searchParams }) => {
  const [toggleFourth, setToggleFourth] = useState(false);
  const [checked, setChecked] = useState([]);
  const [jobTypesOptions, setJobTypesOptions] = useState([]);

  useEffect(() => {
    getJobIndustries()
      .then((res) => {
        // Accessing the data array from response
        setJobTypesOptions(res?.data?.data || res?.data || []);
      })
      .catch(console.log);
  }, []);

  // Sync with URL query parameter
  const jobTypeParam = searchParams.get("JobTypeCategoryIds");

  useEffect(() => {
    if (jobTypeParam) {
      setChecked(jobTypeParam.split(","));
    } else {
      setChecked([]);
    }
  }, [jobTypeParam]);

  // Handle multi-select toggle mapping by ID
  const handleToggle = (value) => {
    const stringValue = String(value);

    window.scrollTo({
      top: 250,
      behavior: "smooth",
    });

    let updatedChecked = [...checked];
    const index = updatedChecked.indexOf(stringValue);

    if (index === -1) {
      updatedChecked.push(stringValue);
    } else {
      updatedChecked.splice(index, 1);
    }

    if (updatedChecked.length > 0) {
      setChecked(updatedChecked);
      onFilterChange("JobTypeCategoryIds", updatedChecked.join(","));
    } else {
      setChecked([]);
      handleClearFilter("JobTypeCategoryIds");
    }
  };

  return (
    <div className="accordion-item border rounded-3 shadow-sm overflow-hidden mt-3">
      <h2 className="accordion-header" id="jobTypeCategory">
        <Button
          className={`accordion-button fw-bold bg-white text-dark py-3 px-4 shadow-none d-flex justify-content-between align-items-center ${
            toggleFourth ? "" : "collapsed"
          }`}
          onClick={(e) => {
            e.preventDefault();
            setToggleFourth(!toggleFourth);
          }}
          role="button"
          id="collapseExample"
        >
          <span>Sort By Industry</span>
          {checked.length > 0 && (
            <span className="badge bg-soft-primary text-primary rounded-pill fs-12 px-2 py-1 me-3">
              {checked.length} Selected
            </span>
          )}
        </Button>
      </h2>
      <Collapse isOpen={toggleFourth}>
        <div className="accordion-body bg-white p-4 pt-2">
          <div className="side-title form-check-all">
            {/* --- All Options --- */}
            <div className="form-check d-flex align-items-center py-1 rounded transition-all">
              <Input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="checkAll"
                value=""
                checked={checked.length === 0}
                onChange={() => {
                  setChecked([]);
                  handleClearFilter("JobTypeCategoryIds");
                }}
              />
              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  checked.length === 0 ? "text-dark fw-semibold" : "text-muted"
                }`}
                htmlFor="checkAll"
              >
                All Industries
              </Label>
            </div>

            {/* --- Dynamic Categories Map Loop --- */}
            {jobTypesOptions.map((type) => {
              const typeIdStr = String(type.id);
              const inputId = `jobTypeCheck-${type.id}`;
              const isChecked = checked.includes(typeIdStr);

              return (
                <div
                  key={type.id}
                  className="form-check d-flex align-items-center justify-content-between py-1 mt-2 rounded transition-all"
                >
                  <div className="d-flex align-items-center w-100">
                    <Input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      name="jobType"
                      value={type.id}
                      id={inputId}
                      checked={isChecked}
                      onChange={() => handleToggle(type.id)}
                    />

                    <Label
                      className={`form-check-label ms-2 cursor-pointer w-100 d-flex justify-content-between align-items-center ${
                        isChecked ? "text-dark fw-semibold" : "text-muted"
                      }`}
                      htmlFor={inputId}
                    >
                      <span>{type.name}</span>
                    </Label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default JobType;
